var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-list-item",
    [
      _c(
        "v-list-item-content",
        [
          _c("v-list-item-title", [
            _vm._v(" Modello "),
            _c("strong", [_vm._v(_vm._s(_vm.item.modelloOrigine))]),
            _vm._v(", Zona "),
            _c("strong", [
              _vm._v(
                _vm._s(_vm.item.zona) + " (" + _vm._s(_vm.item.codiceZona) + ")"
              ),
            ]),
            _vm._v(", capi Ordinati "),
            _c("strong", [_vm._v(_vm._s(_vm.item.capiOrdinati))]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }